import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AccommodationsDataService } from '../accommodations-data.service';
import { AccommodationsService } from '../accommodations.service';
import { DialogData, RoomKind, Users } from '../accommodations.model';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { AccommodationsReservationsDokComponent } from './accommodations-reservations-dok/accommodations-reservations-dok.component';

@Component({
	selector: 'app-accommodations-reservation',
	templateUrl: './accommodations-reservation.component.html',
	styleUrls: ['./accommodations-reservation.component.scss'],
})
export class AccommodationsReservationComponent implements OnInit {
	protected reservations = [];
	protected reservationsNumber = [];
	protected roomId = null;
	protected roomKind = 1;
	protected users: Users[] = [];
	protected notesIsTour;
	protected notesIsTourLength = 0;
	protected notesAccomodationFile;
	protected newNotesAccomodationFile = null;
	protected notesAccomodationFileLength = 0;

	constructor(
		private readonly dataService: AccommodationsDataService,
		private readonly service: AccommodationsService,
		private readonly question: QuestionService,
		private readonly loader: LoaderService,
		private readonly erp: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
	) {}

	ngOnInit(): void {
		if (this.data.istourreservationSet.length) {
			this.parseIsTourReservation();
		} else {
			this.parseReservation();
		}
	}

	protected parseReservation() {
		this.data.offerSlot.forEach((v) => {
			const parseUserData = {
				firstName: v.userData?.firstName,
				lastName: v.userData?.lastName,
				birthDate: v.userData?.birth,
				phone: v.userData?.userContacts.map((x) => x.phone),
				businessCaseId: null,
			};
			this.users.push(parseUserData);
		});
		this.reservations.push({ isTourNumber: this.data.reservation });
	}

	protected parseIsTourReservation() {
		this.reservations = this.data.istourreservationSet;
		if (
			this.reservations[0].kind === RoomKind.NAME_OPTION ||
			this.reservations[0].kind === RoomKind.NO_NAME_OPTION ||
			this.reservations.length > 1
		) {
			this.roomKind = 2;
		}
		this.roomId = this.data.room;
		this.dataService.loadStateDetails(this.data.id).then((result) => {
			this.users = result.data.customers;
			this.notesIsTour = result.data.notesIsTour;
			if (this.notesIsTour.length != 0) {
				this.notesIsTourLength = 1;
			}
			this.notesAccomodationFile = result.data.notesAccomodationFile;
			if (this.notesAccomodationFile.length != 0) {
				this.notesAccomodationFileLength = 1;
			}
			this.users.forEach((obj) => this.reservationsNumber.push(obj.businessCaseId));
		});
	}

	protected moveStart(reservation, type): void {
		if (!reservation.guarantee) {
			this.service.reservationMove = {
				type: type,
				reservation: reservation,
			};
			return;
		}
		const question = this.question
			.ask('To jest rezerwacja z gwarancją pokoju. Czy na pewno przenieść?', 'reservationMoveStart')
			.subscribe((result) => {
				if (result.dialogId !== 'reservationMoveStart') {
					return;
				}
				question.unsubscribe();
				if (!result.result) {
					return;
				}
				this.service.reservationMove = {
					type: type,
					reservation: reservation,
				};
			});
	}

	evictRoom(reservation): Promise<any> {
		return new Promise((resolve) => {
			this.loader.show('evictRoom');
			this.erp.command(
				`/Bag/BagIstourAccomodation/`,
				{
					cmd: 'evictRoom',
					roomAvailabilityState: reservation[0].roomAvailabilityState,
				},
				(result, error) => {
					if (error) {
						return;
					}
					this.dataService.loadReservationWithOutRoom();
					this.dataService.loadAvailabilities();
					this.loader.hide('evictRoom');
					resolve(result);
				},
			);
		});
	}

	findDoks(): Promise<any> {
		return new Promise((resolve) => {
			this.loader.show('findDoks');
			this.erp.command(
				`/Bag/BagIstourAccomodation/`,
				{
					cmd: 'findDoks',
					data: this.reservations,
				},
				(result, error) => {
					if (error) {
						return;
					}
					this.loader.hide('findDoks');

					const dialogRef = this.dialog
						.open(AccommodationsReservationsDokComponent, {
							data: [this.reservations[0].roomAvailabilityState, result.data],
							disableClose: false,
						})
						.afterClosed()
						.subscribe((result) => {
							this.dataService.loadReservationWithOutRoom();
							dialogRef.unsubscribe();
							if (!result) {
								return;
							}
						});
				},
			);
		});
	}

	diDoc(pos) {
		this.loader.show('diDoc');
		this.erp.command(
			`/Bag/BagIstourAccomodation/`,
			{
				cmd: 'diDok',
				capacitie: pos.businessCasesCapacities,
				state: this.reservations[0].roomAvailabilityState,
				bagIsTourReservetion: pos.bagIsTourReservetion,
			},
			(result, error) => {
				if (error) {
					return;
				}
				this.dataService.loadReservationWithOutRoom();
				this.loader.hide('diDoc');
			},
		);
	}

	saveComment(kind, pos) {
		if (kind === 'new') {
			this.loader.show('saveComment');
			this.erp.command(
				`/Bag/BagIstourAccomodation/`,
				{
					cmd: 'saveComment',
					kind: kind,
					notes: this.newNotesAccomodationFile,
					reservations: this.reservationsNumber,
				},
				(result, error) => {
					if (error) {
						return;
					}
					this.loader.hide('diDoc');
				},
			);
		} else {
			this.erp.command(
				`/Bag/BagIstourAccomodation/`,
				{
					cmd: 'saveComment',
					kind: kind,
					notes: pos.content,
					reservations: [pos.businessCase],
				},
				(result, error) => {
					if (error) {
						return;
					}
					this.loader.hide('diDoc');
				},
			);
		}
		this.loader.hide('saveComment');
	}

	changeRoomBAG(data) {
		this.service.changeRoomBAG(data);
	}

	removeStateFromOffer(data) {
		this.service.removeStateFromOffer(data);
	}
}
